import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import { Box, Heading, Text } from '../../index';

interface ErrorSummaryProps {
  errors: Array<{
    field: string;
    message: string;
    label?: string;
  }>;
  title?: string;
  onFieldClick?: (field: string) => void;
  className?: string;
}

export function ErrorSummary({
  errors,
  title = 'Please correct the following errors:',
  onFieldClick,
  className = '',
}: ErrorSummaryProps) {
  if (errors.length === 0) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
      >
        <Box
          border="1px solid"
          borderColor="#FCA5A5"
          backgroundColor="#FEF2F2"
          borderRadius="8px"
          padding="16px"
          marginBottom="24px"
          className={className}
        >
          <Heading as="h3" fontSize="16px" fontWeight="600" color="#DC2626" marginBottom="12px">
            {title}
          </Heading>

          <Box as="ul" margin={0} paddingLeft="20px">
            {errors.map((error, index) => (
              <Box as="li" key={`${error.field}-${index}`} marginBottom="8px">
                <Text
                  color="#DC2626"
                  textDecoration="underline"
                  cursor="pointer"
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    onFieldClick?.(error.field);
                  }}
                >
                  {error.label || error.field}
                </Text>
                <Text as="span" color="#7F1D1D" marginLeft="8px">
                  - {error.message}
                </Text>
              </Box>
            ))}
          </Box>
        </Box>
      </motion.div>
    </AnimatePresence>
  );
}
